import React from 'react';
import './AdminStats.css';

const AdminStats = ({ events }) => {
  // Calculate statistics
  const totalEvents = events.length;
  const dcEvents = events.filter(e => e.region === 'DC' || !e.region).length;
  const nycEvents = events.filter(e => e.region === 'NYC').length;
  
  // Category breakdown
  const categories = events.reduce((acc, event) => {
    const category = event.categoryPrimary || event.category || 'Uncategorized';
    acc[category] = (acc[category] || 0) + 1;
    return acc;
  }, {});

  // Format breakdown
  const formats = events.reduce((acc, event) => {
    const format = event.format || 'Unknown';
    acc[format] = (acc[format] || 0) + 1;
    return acc;
  }, {});

  // Recent events (last 7 days)
  const recentEvents = events.filter(event => {
    const eventDate = new Date(event.start_time || event.date || Date.now());
    const weekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    return eventDate > weekAgo;
  }).length;

  const stats = [
    {
      title: 'Total Events',
      value: totalEvents.toLocaleString(),
      icon: '📅',
      color: '#3b82f6'
    },
    {
      title: 'DC Events',
      value: dcEvents.toLocaleString(),
      icon: '🏛️',
      color: '#10b981'
    },
    {
      title: 'NYC Events',
      value: nycEvents.toLocaleString(),
      icon: '🗽',
      color: '#f59e0b'
    },
    {
      title: 'Recent (7 days)',
      value: recentEvents.toLocaleString(),
      icon: '🆕',
      color: '#ef4444'
    }
  ];

  return (
    <div className="admin-stats">
      {/* Overview Cards */}
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: stat.color + '20' }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <div className="stat-value" style={{ color: stat.color }}>
                {stat.value}
              </div>
              <div className="stat-title">{stat.title}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Detailed Breakdowns */}
      <div className="stats-breakdown">
        <div className="breakdown-card">
          <h3>📊 Categories</h3>
          <div className="breakdown-list">
            {Object.entries(categories)
              .sort(([,a], [,b]) => b - a)
              .slice(0, 10)
              .map(([category, count]) => (
                <div key={category} className="breakdown-item">
                  <span className="breakdown-label">{category}</span>
                  <span className="breakdown-count">{count}</span>
                </div>
              ))}
          </div>
        </div>

        <div className="breakdown-card">
          <h3>🎭 Formats</h3>
          <div className="breakdown-list">
            {Object.entries(formats)
              .sort(([,a], [,b]) => b - a)
              .map(([format, count]) => (
                <div key={format} className="breakdown-item">
                  <span className="breakdown-label">{format}</span>
                  <span className="breakdown-count">{count}</span>
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <h3>⚡ Quick Actions</h3>
        <div className="actions-grid">
          <div className="action-card">
            <div className="action-icon">📊</div>
            <div className="action-content">
              <h4>Export Data</h4>
              <p>Download all events as CSV/JSON</p>
            </div>
          </div>
          <div className="action-card">
            <div className="action-icon">🔍</div>
            <div className="action-content">
              <h4>Data Health</h4>
              <p>Check for missing or invalid data</p>
            </div>
          </div>
          <div className="action-card">
            <div className="action-icon">🔄</div>
            <div className="action-content">
              <h4>Sync Status</h4>
              <p>Last updated: Just now</p>
            </div>
          </div>
          <div className="action-card">
            <div className="action-icon">📈</div>
            <div className="action-content">
              <h4>Analytics</h4>
              <p>View event performance metrics</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminStats;
